import React from "react";
import { FormattedMessage } from "react-intl";
import styles from "./UserRating.module.scss";
import { Grid } from "semantic-ui-react";
import { Heading2, Body2 } from "../../value-cssmodules/TextComponent";
import StarRating from "./StarRating";

const UserRating = ({ rating }: { rating: number }) => {
  return (
    <Grid>
      <Grid.Row columns={3} className={styles.rate} />
      <Grid.Column desktop={6} mobile={8}>
        <StarRating rating={rating} size="massive" />
      </Grid.Column>
      <Grid.Column desktop={6} mobile={8}>
        <Body2>
          <FormattedMessage
            id={"nav.commentsrating"}
            defaultMessage={"Rating"}
          />
        </Body2>
        <Heading2>{Number(rating).toPrecision(3)}</Heading2>
      </Grid.Column>
    </Grid>
  );
};

export default UserRating;
